import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateOrg = async (data) => {
  const { name, city, countryId, orgId, logoDataUri } = data
  const url = `v1/orgs/${orgId}`

  return axiosInstance.patch(url, {
    name,
    countryId,
    city,
    logoDataUri,
  })
}

export default updateOrg
